import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Avatar, Typography, useTheme } from '@mui/material';
export const CalendarFootballEvent = ({ logo, teamName, onClick }) => {
    const theme = useTheme();
    return (_jsxs(Box, { onClick: onClick, sx: {
            display: 'flex',
            alignItems: 'center',
            cursor: onClick ? 'pointer' : 'default',
            gap: '6px',
            height: 24
        }, children: [_jsx(Avatar, { src: logo, alt: teamName, sx: {
                    width: 24,
                    height: 24,
                    '& .MuiAvatar-img': {
                        objectFit: 'contain'
                    }
                }, variant: 'rounded' }), _jsx(Typography, { variant: 'caption', sx: {
                    fontWeight: 400,
                    color: theme.palette.text.primary,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }, children: teamName })] }));
};
